(function () {
    var m = angular.module('utils');

    m.directive('phone', [function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModel) {

                if (!scope.fields.phone) {
                    $(elm).val('+7');
                    ngModel.$setViewValue(7);
                } else if (scope.fields.phone) {
                    var temp = scope.fields.phone.toString();
                    if (temp[0] != "7" && temp.length == 10) {
                        scope.fields.phone = "+7" + scope.fields.phone;
                    }
                }

                $(elm).on('keyup paste blur keydown', function () {
                    var viewValue = $(elm).val();
                    var numerified = viewValue.replace(/[^\d]/ig, '').replace(/^7/ig, '');

                    if (numerified && numerified != '') {
                        ngModel.$setViewValue(numerified);
                    } else {
                        ngModel.$setViewValue('');
                    }
                });
            }
        };
    }]);
})();
